/* VENZE · Ingredientes (sección venze-ingredients-explorer) */
(function () {
  function initVIX(root) {
    if (!root || root.dataset.vixInit === '1') return;
    root.dataset.vixInit = '1';

    var track = root.querySelector('[data-vix-track]');
    var slides = root.querySelectorAll('[data-vix-slide]');
    var tabs = root.querySelectorAll('[data-vix-tab]');
    var panels = root.querySelectorAll('[data-vix-panel]');
    var segs = root.querySelectorAll('[data-vix-seg]');
    var list = root.querySelector('[data-vix-list]');
    var current = root.querySelector('[data-vix-current]');
    var total = slides.length;
    if (!total) return;
    var mq = window.matchMedia('(min-width: 750px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = parseInt(root.dataset.vixStart || '0', 10) || 0;
    var lockTarget = null;
    var lockTimer = null;
    var settleTimer = null;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function centerChip(i, smooth) {
      if (mq.matches || !list || !tabs[i]) return;
      var t = tabs[i];
      var left = t.offsetLeft - (list.clientWidth - t.offsetWidth) / 2;
      list.scrollTo({ left: Math.max(0, left), behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }

    function releaseLock() {
      lockTarget = null;
      clearTimeout(lockTimer);
      if (track) track.style.scrollSnapType = '';
    }

    function scrollTrackTo(i, smooth) {
      if (mq.matches || !track) return;
      var target = i * track.clientWidth;
      if (Math.abs(track.scrollLeft - target) < 2) return;
      lockTarget = target;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: target, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        if (track) track.scrollLeft = target;
        releaseLock();
      }, 1400);
    }

    function select(i, opts) {
      opts = opts || {};
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      var changed = i !== active;
      active = i;
      for (var k = 0; k < total; k++) {
        var on = k === i;
        if (slides[k]) {
          slides[k].classList.toggle('is-active', on);
          if (on) slides[k].removeAttribute('aria-hidden'); else slides[k].setAttribute('aria-hidden', 'true');
        }
        if (tabs[k]) {
          tabs[k].classList.toggle('is-active', on);
          tabs[k].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[k].setAttribute('tabindex', on ? '0' : '-1');
        }
        if (panels[k]) {
          if (on) {
            panels[k].hidden = false;
            if (changed && !reduce) {
              panels[k].classList.remove('is-entering');
              void panels[k].offsetWidth;
              panels[k].classList.add('is-entering');
            }
          } else {
            panels[k].hidden = true;
          }
        }
        if (segs[k]) segs[k].classList.toggle('is-active', on);
      }
      if (current) current.textContent = pad(i + 1);
      if (!opts.fromScroll) scrollTrackTo(i, opts.smooth !== false);
      centerChip(i, true);
      if (opts.focus && tabs[i]) tabs[i].focus({ preventScroll: true });
    }

    Array.prototype.forEach.call(tabs, function (tab, k) {
      tab.addEventListener('click', function () { select(k); });
      tab.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'ArrowRight' || key === 'ArrowDown') { e.preventDefault(); select(active + 1, { focus: true }); }
        else if (key === 'ArrowLeft' || key === 'ArrowUp') { e.preventDefault(); select(active - 1, { focus: true }); }
        else if (key === 'Home') { e.preventDefault(); select(0, { focus: true }); }
        else if (key === 'End') { e.preventDefault(); select(total - 1, { focus: true }); }
      });
    });

    var prev = root.querySelector('[data-vix-prev]');
    var next = root.querySelector('[data-vix-next]');
    if (prev) prev.addEventListener('click', function () { select(active - 1); });
    if (next) next.addEventListener('click', function () { select(active + 1); });

    if (track) {
      track.addEventListener('scroll', function () {
        if (mq.matches) return;
        if (lockTarget !== null) {
          if (Math.abs(track.scrollLeft - lockTarget) < 2) releaseLock();
          return;
        }
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== active && i >= 0 && i < total) select(i, { fromScroll: true });
        }, 90);
      }, { passive: true });
    }

    function onBreakpoint() {
      releaseLock();
      if (!mq.matches && track) {
        track.scrollLeft = active * track.clientWidth;
        centerChip(active, false);
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint); else if (mq.addListener) mq.addListener(onBreakpoint);

    root._vixSelectBlock = function (blockId) {
      for (var k = 0; k < tabs.length; k++) {
        if (tabs[k].dataset.blockId === blockId) { select(k); return; }
      }
    };

    if (!mq.matches) {
      requestAnimationFrame(function () {
        if (track) track.scrollLeft = active * track.clientWidth;
        centerChip(active, false);
      });
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.vix-section');
    Array.prototype.forEach.call(nodes, initVIX);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('.vix-section') : null;
    if (s && s._vixSelectBlock && e.detail) s._vixSelectBlock(e.detail.blockId);
  });
})();